import { Instance, SnapshotOut, types } from 'mobx-state-tree'

import { AgoraStoreModel } from './agora.store'
import { ChannelStoreModel } from './channel.store'
import { ChatStoreModel } from './chat.store'

/**
 * A CommunicationStore model.
 */
export const CommunicationStore = types.compose(AgoraStoreModel, ChannelStoreModel, ChatStoreModel)

/**
 * The CommunicationStore instance.
 */
export type CommunicationStoreType = Instance<typeof CommunicationStore>

/**
 * The data of a CommunicationStore.
 */
export type CommunicationStoreSnapshot = SnapshotOut<typeof CommunicationStore>
